export type DeployEnv = 'dev' | 'test' | 'prod'

export const deployEnv = process.env.VUE_APP_DEPLOY_ENV as DeployEnv
